<template>
    <v-data-table
        class="my-2"
        :headers="headers"
        :items="items"
        :loading="loading"
        :options.sync="pagination"
        :footer-props="{'items-per-page-options': pagination.itemsPerPageOptions}"
        :no-data-text="noDataText"
        :must-sort="true"
    >
        <template slot="item" slot-scope="props">
          <tr>
            <td class="text-caption">{{ formatDate(props.item.updated_at) }}</td>
            <td class="text-caption">{{ props.item.facility.location_code }}</td>
            <td class="text-caption">{{ props.item.customer_first_name }} {{ props.item.customer_last_name }}</td>
            <td class="text-caption">{{ props.item.customer_email }}</td>
            <td class="text-caption">{{ props.item.customer_phone }}</td>
            <td class="text-caption">{{ props.item.tenant_id }}</td>
            <td class="text-caption">
                <v-layout column align-center>
                    <v-layout justify-center>
                        <v-icon v-if="nameMatch(props.item.match)" class="success--text">check</v-icon>
                        <v-icon v-else class="error--text">close</v-icon>
                    </v-layout>
                    <v-flex class="mt-1">{{ props.item.matched_tenant_name }}</v-flex>
                </v-layout>
            </td>
            <td class="text-caption">
                <v-layout column align-center>
                    <v-layout justify-center>
                        <v-icon v-if="emailMatch(props.item.match)" class="success--text">check</v-icon>
                        <v-icon v-else class="error--text">close</v-icon>
                    </v-layout>
                    <v-flex class="mt-1">{{ props.item.matched_tenant_email }}</v-flex>
                </v-layout>
            </td>
            <td class="text-caption">
                <v-layout column align-center>
                    <v-layout justify-center>
                        <v-icon v-if="phoneMatch(props.item.match)" class="success--text">check</v-icon>
                        <v-icon v-else class="error--text">close</v-icon>
                    </v-layout>
                    <v-flex class="mt-1">{{ addDashes(props.item.matched_tenant_phone) }}</v-flex>
                </v-layout>
            </td>
            <td class="text-caption">
                <v-flex v-if="props.item.matched_tenant_id">{{ props.item.matched_tenant_id }}</v-flex>
                <v-flex v-else>N/A</v-flex>
            </td>
            <td>
                <v-layout column class="my-1 text-h5">
                    <v-btn
                        data-testid="audit-approve-btn"
                        class="audit-approve-btn success my-1"
                        block
                        small
                        v-if="type == 'queue' || type == 'denied'"
                        @click="handleDeal(props.item.id, 'approve')"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                        data-testid="audit-deny-btn"
                        class="audit-deny-btn error my-1"
                        block
                        small
                        v-if="type == 'queue' || type == 'approved'"
                        @click="handleDeal(props.item.id, 'deny')"
                    >
                      Deny
                    </v-btn>
                </v-layout>
            </td>
          </tr>
        </template>
    </v-data-table>
</template>

<script>
/* eslint-disable eqeqeq */
import { auditHeaders } from "@/helpers/reporting/audit-data-table-headers";
import { dateMethodMixins } from "@/mixins/dateMethodMixins";

export default {
  props: ["items", "noDataText", "type"],

  mixins: [dateMethodMixins],

  data() {
    return {
      loading: false,

      pagination: {
        itemsPerPage: 25,
        itemsPerPageOptions: [25, 50, 75, 100],
        totalItems: this.items.length,
        sortBy: ["updated_at"],
        sortDesc: [true]
      },

      headers: auditHeaders
    };
  },

  methods: {
    addDashes(phone) {
      if (phone) {
        if (phone.length === 10 && typeof phone.replace === "function") {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          return phone;
        }
      }
    },

    center(text) {
      return !!((text == "Name Match" || text == "Email Match" || text == "Phone Match"));
    },

    nameMatch(value) {
      return value % 2 !== 0;
    },

    phoneMatch(value) {
      return !!(value == 2 || value == 3 || value >= 6);
    },

    emailMatch(value) {
      return value >= 4;
    },

    handleDeal(id, action) {
      let payload = {
        converted: action == "approve",
        reservationId: id
      };

      this.$store.dispatch("manualConversion", payload)
        .then(() => {
          this.$store.dispatch("handleSuccess", "Deal updated successfully!");
          this.$emit("dealReviewed");
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
        });
    }
  }
};
</script>
